import { cache } from '@/container/apollo-client/cache';
import { CURSOR_LIST_PAYMENT_ORDERS } from '@/graphql/cursor.graphql';
import {
  ListPaymentOrdersQuery,
  ListPaymentOrdersQueryVariables,
  PaymentOrderLienStatusEnum,
  useworkspaceAuthMeV2Query,
  usePaymentOrderCreatedSubscription,
} from '@/types/generated/graphql';
import { cacheOnly } from '@shared/constants';
import { CONFIRM_PAYMENT_BADGE_VARIABLES } from '@components/confirm-payment/confirm-payment.constants';

export function usePaymentOrderNotifications() {
  const { data: workspaceAuthMe } = useworkspaceAuthMeV2Query(cacheOnly);
  const currentWorkspaceId = workspaceAuthMe?.workspaceAuthMeV2?.data?.id;

  usePaymentOrderCreatedSubscription({
    onData: ({ data }) => {
      const order = data?.data?.paymentOrderCreated;
      if (!order) return;
      if (order.workspaceId !== currentWorkspaceId) return;
      if (order.lienStatus !== PaymentOrderLienStatusEnum.confirmation_requested) return;

      const existing = cache.readQuery<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>({
        query: CURSOR_LIST_PAYMENT_ORDERS,
        variables: CONFIRM_PAYMENT_BADGE_VARIABLES,
      });

      const existingOrders = existing?.listPaymentOrders?.data ?? [];
      if (existingOrders.some((item) => item?.id === order.id)) return;

      cache.writeQuery<ListPaymentOrdersQuery, ListPaymentOrdersQueryVariables>({
        query: CURSOR_LIST_PAYMENT_ORDERS,
        variables: CONFIRM_PAYMENT_BADGE_VARIABLES,
        data: {
          listPaymentOrders: {
            __typename: 'CursorPaginationPaymentOrders',
            message: existing?.listPaymentOrders?.message ?? '',
            data: [
              ...existingOrders,
              { __typename: 'PaymentOrder', id: order.id, lienStatus: order.lienStatus, createdAt: order.createdAt },
            ],
            cursor: existing?.listPaymentOrders?.cursor ?? null,
          },
        },
      });
    },
  });
}
